import '../../css/types/image.css';
import '../../css/types/image-stub.css';

export const ImageStub = {
	name: 'ui-image-stack-steps-image-stub',
	template: `
		<div class="ui-image-stack-steps-image --image-stub"></div>
	`,
};
